import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import LoadingSpinner from '../../LoadingSpinner';
import { useGetInstagramConfigurationQuery } from '../../../Services/settingsAPIs/CommonAPI';
import InstagramModal from './instagramModal';
import DeleteInstagramModal from './DeleteInstagramModal';

const InstagramConfiguration = () => {
    // State to manage the enable/disable status
    const [editModal, setEditModal] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [modalOpenStatus, setModalOpenStatus] = useState<any>("configure")
    const [isDeleteButtonClicked, setIsDeleteButtonClicked] = useState(false);
    const [seletedEditData, setSeletedEditData] = useState<any>([])
    const [instagramConfigurationInfo, setInstagramConfigurationInfo] = useState<any>([])
    const [deleteId, setDeleteId] = useState<any>("")
    const defaultCompactFormModalStyles = {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "600px",
            maxWidth: "850px", // Max width for larger screens
            height: "50%",
            margin: "auto",
            Overflow: "hidden",
            OverflowY: "auto",
            background: "#ffffff",
        },
    };

    const { data: instagramConfigurationData, status: getInstagramConfigurationDataStatus, refetch } = useGetInstagramConfigurationQuery({});
    // Handler for toggling WhatsApp configuration


    useEffect(() => {
        if (getInstagramConfigurationDataStatus === "pending") {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }
    }, [getInstagramConfigurationDataStatus]);

    useEffect(() => {
        if (instagramConfigurationData) {
            setInstagramConfigurationInfo(instagramConfigurationData);
        }
    }, [instagramConfigurationData]);

    const closeEditModal = () => {
        setEditModal(false);
    };
    const openEditModal = (modalstatus, item) => {
        setModalOpenStatus(modalstatus)
        setSeletedEditData(item)
        setEditModal(true)
    }
    const openDeleteModal = (id) => {
        // Optionally track the id to delete, if needed:
        setDeleteId(id);
        setIsDeleteButtonClicked(true);
    };

    const closeDeleteModal = () => {
        setIsDeleteButtonClicked(false);
    };



    const deleteCustomModalStyles: ReactModal.Styles = {
        content: {
            top: "50%",
            left: "50%",
            width: "30%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
        },
    };

    return (
        <div style={{ marginLeft: "3%", marginRight: "3%" }}>
            <div className='row'>
                <div className={`col-${instagramConfigurationInfo?.results?.length === 0 ? "10" : "12"}`}>
                    <span className="input-group-text mt-2" id="basic-addon1">
                        Instagram configuration
                    </span>
                </div>

                {instagramConfigurationInfo?.results?.length === 0 &&

                    <div className='col'>

                        <div
                            className="mt-2"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: '20px',
                                alignItems: 'center',
                            }}
                        >

                            {/* Show the Configure button only when isWhatsAppEnabled is true */}

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => openEditModal("configure", null)}
                            >
                                Configure
                            </button>

                        </div>
                    </div>
                }
            </div>

            {isLoading ? <LoadingSpinner /> : (<>

                <div className="row mx-0 mb-2 rounded-3 py-4" style={{ maxHeight: "60vh", marginBottom: "50px" }}>
                    <div className="row" style={{ tableLayout: 'fixed', borderCollapse: 'collapse', paddingRight: "0px" }}>
                        <div
                            className="col px-2"
                            style={{ paddingRight: "5px", paddingLeft: "5px" }}
                        >
                            <div
                                className="card px-2 my-1 min-w-600px"
                                style={{
                                    backgroundColor: "#E4E4E47F",
                                }}
                            >
                                {/* Header */}
                                <div className="row align-items-center py-4">
                                    <div className="col text-start ps-5">
                                        <strong>Sr.No</strong>
                                    </div>
                                    <div className="col text-center">
                                        <strong>Access token</strong>
                                    </div>
                                    <div className="col text-center">
                                        <strong>IG user id</strong>
                                    </div>
                                    <div className="col text-end me-2">
                                        <strong style={{ paddingRight: "10px" }}>Actions</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Rows */}

                    <div className="row" style={{ tableLayout: 'fixed', borderCollapse: 'collapse', paddingRight: "0px" }}>
                        <div
                            className="col px-2"
                            style={{ paddingRight: "5px", paddingLeft: "5px" }}
                        >
                            {instagramConfigurationInfo?.results && instagramConfigurationInfo?.results.map((item, index) => (
                                <div
                                    className="card px-2 my-1 min-w-600px"
                                    draggable="true"
                                    style={{ cursor: "grab", padding: "7px 0px" }}
                                    key={index}
                                >
                                    <div className="row align-items-center">
                                        {/* ID */}
                                        <div className="col text-start ps-5">
                                            <label>{index + 1}</label>
                                        </div>

                                        {/* Phone Number ID */}
                                        <div className="col text-center">
                                            <label
                                                title={item.access_token} // Tooltip on hover
                                                style={{ cursor: "pointer", userSelect: "all" }}
                                            >
                                                {item.access_token && item.access_token.length > 15
                                                    ? `${item.access_token.slice(0, 20)}...`
                                                    : item.access_token}
                                            </label>
                                        </div>

                                        {/* User Access Token */}
                                        <div className="col text-center">
                                            <label>{item.user_id
                                            }</label>
                                        </div>

                                        {/* Actions */}
                                        <div className="col text-end me-6">
                                            <button
                                                className="text-hover-primary border-0 bg-white me-2"
                                                title="Edit"
                                                onClick={() => openEditModal("edit", item)}
                                            >
                                                <i className="bi bi-pencil fs-4"></i>
                                            </button>
                                            <button
                                                className="text-hover-danger border-0 bg-white"
                                                title="Delete"
                                                onClick={() => openDeleteModal(item.id)}

                                            >
                                                <i className="bi bi-trash fs-4"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>


            </>)}

            <ReactModal
                isOpen={editModal}
                onRequestClose={closeEditModal}
                style={defaultCompactFormModalStyles}
            >
                <InstagramModal
                    closeModal={closeEditModal}
                    editModalData={seletedEditData}
                    editModal={editModal}
                    modalOpenStatus={modalOpenStatus}
                    refetch={refetch}
                />
            </ReactModal>

            <ReactModal
                isOpen={isDeleteButtonClicked}
                onRequestClose={closeDeleteModal}
                style={deleteCustomModalStyles}
            >
                <DeleteInstagramModal
                    closeModal={closeDeleteModal}
                    fieldsData={deleteId}
                    refetch={refetch}
                />
            </ReactModal>
        </div>
    );
};

export default InstagramConfiguration;